import { Injectable } from '@angular/core';
import { DesktopUserDataService } from './desktop-user-data.service';

@Injectable()
export class DesktopUserPreferencesService {

    constructor(
        private desktopUserDataService: DesktopUserDataService
    ){
    }

    /**
     * Set full ebooks userPreferences for a user to the DB
     * @param userPreferencesData : {uid, ebookCode, data}
     * @param uid : userId
     * @param ebookCode : ebookCode
     * @param data : userPreferences data as fetched from server
     * @returns 
     */
    setBulkUserPreferences(userPreferencesData){
        userPreferencesData.userDataType = this.desktopUserDataService.USER_DATA_TYPES.PREFERENCE;
        return this.desktopUserDataService.setBulkRecords(userPreferencesData);    
    }

    /**
     * method to update a userPreference
     * @param userPreferenceUpdateData {uid, ebookCode, data}
     * data : userPreferences data -> Structure same as fetched from server
     * @returns 
     */
    updateUserPreference(userPreferenceUpdateData){
        userPreferenceUpdateData.userDataType = this.desktopUserDataService.USER_DATA_TYPES.PREFERENCE;
        return this.desktopUserDataService.updateRecord(userPreferenceUpdateData); 
    }

    /**
     * method to get userPreference(s) of an ebook for a user
     * @param params : {uid, ebookCode, documentId?}
     */
    getUserPreferences(params){
        params.userDataType = this.desktopUserDataService.USER_DATA_TYPES.PREFERENCE;
        return this.desktopUserDataService.getRecords(params); 
    }


    /**
     * method to delete userPreference(s) of an ebook for a user
     * @param params : {uid, ebookCode, documentId?}
     * @param uid : userId
     * @param ebookCode : ebookCode
     * @param documentId : if given, only one userPreference will be deleted.
     * If no documentId is passed then all the userPreferences will be deleted
     */
     deleteUserPreferences(params){
        params.userDataType = this.desktopUserDataService.USER_DATA_TYPES.PREFERENCE;
        return this.desktopUserDataService.deleteRecords(params); 
    }
    
}